import { useI18n } from "vue-i18n";
import { computed, watch } from "vue";
import { useLocalStorage } from "@vueuse/core";

import { TLangCode } from "../types";
import { LANGUAGES } from "../constants";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export const useLanguage = () => {
  const { locale } = useI18n();
  const vuexStore = useStore();
  const route = useRoute();
  const savedLanguageCode = useLocalStorage("selected-language", "ru");

  const systemCountry = computed(() => vuexStore.state.system.system_country);

  const currentLanguageLabel = computed(
    () => LANGUAGES.find((lang) => lang.code === savedLanguageCode.value)!.label
  );

  const switchLanguage = (langCode: TLangCode) => {
    locale.value = langCode;
    savedLanguageCode.value = locale.value;
  };

  watch(
    systemCountry,
    (country) => {
      if (
        ["kz", "md", "ru", "kg", "uz"].includes(country) &&
        typeof route.name === "string" &&
        ["Login", "Registration"].includes(route.name)
      ) {
        console.log("switch to ru lang into useLanguage compos");
        switchLanguage("ru");
      }
    },
    { immediate: true }
  );

  return {
    savedLanguageCode,
    currentLanguageLabel,
    switchLanguage,
  };
};
